import Snackbar from "./snackbar";

/**
 * This class is used to print labels using zebra printer.
 */
export default class ZebraPrint {
    constructor() {
        if (typeof window.BrowserPrint !== "undefined") {
            this.browserPrint = window.BrowserPrint;
            this.setup = this.setup.bind(this);
            this.print = this.print.bind(this);
            this.snackbar = new Snackbar();
            this.errorMessages = [];

            this.printSuccess = this.printSuccess.bind(this);
            this.printError = this.printError.bind(this);

            this.printPaxLabel = document.querySelectorAll(".print-pax-label");
            if (this.printPaxLabel.length > 0) {
                this.printPaxLabel.forEach((printLabelBtn) => {
                    printLabelBtn.addEventListener("click", this.print);
                });
            }
        }
    }

    print(event) {
        this.printSuccess("Printing in progress");

        // Step 1 : Setup printing device
        new Promise((resolve, reject) => {
            this.setup(resolve, reject);
        })
            // Step 2 : Check if we can read on print
            .then((device) => {
                this.selectedDevice = device;

                return new Promise((resolve, reject) => {
                    this.selectedDevice.read(() => {
                        resolve("ok");
                    }, (error) => {
                        reject([error]); // eslint-disable-line prefer-promise-reject-errors
                    });
                });

            // Step 3 : Check device status (out of paper, door open,..)
            })
            .then(() => new Promise((resolve, reject) => {
                this.selectedDevice.sendThenRead("~HQES", (text) => {
                    const errors = [];
                    if (!text) {
                        errors.push("Error with printing connection, try to reboot the printer");
                    }

                    const isError = text.charAt(70);
                    const media = text.charAt(88);
                    const head = text.charAt(87);
                    const pause = text.charAt(84);

                    if (media === "1") {
                        errors.push("Paper out");
                    }
                    if (media === "2") {
                        errors.push("Ribbon Out");
                    }
                    if (media === "4") {
                        errors.push("Media Door Open");
                    }
                    if (media === "8") {
                        errors.push("Cutter Fault");
                    }
                    if (head === "1") {
                        errors.push("Printhead Overheating");
                    }
                    if (head === "2") {
                        errors.push("Motor Overheating");
                    }
                    if (head === "4") {
                        errors.push("Printhead Fault");
                    }
                    if (head === "8") {
                        errors.push("Incorrect Printhead");
                    }
                    if (pause === "1") {
                        errors.push("Printer Paused");
                    }
                    if (isError !== "0" && errors.length === 0) {
                        errors.push("Unknown Error");
                    }

                    if (errors.length > 0) {
                        reject(errors);
                    } else {
                        resolve("ok");
                    }
                });
            }))
            // Step 4 : Launch printing
            .then(() => {
                fetch(event.target.dataset.url, {
                    credentials: "include",
                }).then((response) => {
                    response.json().then((printDesign) => {
                        this.selectedDevice.send(
                            printDesign,
                            this.printSuccess.bind(this, ("Label has been printed successfully")),
                            this.printError.bind(this, ("There was an issue during printing.")),
                        );
                    });
                }).catch((error) => {
                    console.log(`There has been a problem with your fetch operation: ${error.message}`);
                });
            })
            .catch((errors) => {
                errors.forEach((error) => {
                    this.errorMessages.push(error);
                });
                this.printError(this.errorMessages.join(" - "));
            });
    }

    setup(resolve, reject) {
        this.browserPrint.getDefaultDevice("printer", (device) => {
            if (device === null) {
                reject(["No device connected"]);

                return;
            }
            resolve(device);
        }, () => {
            reject(["No default device connected"]);
        });
        this.browserPrint.getLocalDevices((printers) => {
            if (printers === undefined) {
                reject(["No device connected"]);

                return;
            }
            resolve("ok");
        }, undefined, "printer");
    }

    printSuccess(text) {
        this.snackbar.show(text);
    }

    printError(text) {
        this.snackbar.show(text, "error");
        this.errorMessages = [];
    }
}
